<section class="team-panel">
  <header class="team-panel__header">
    <div class="team-panel__heading">
      <h2 class="team-panel__title">Team</h2>
      <p class="team-panel__subtitle">
        Manage who has access to your organization and the locations they can
        work in.
      </p>
      <div class="team-panel__stats" *ngIf="!isLoading && users.length">
        <span class="team-stat">
          <strong>{{ users.length }}</strong>
          {{ users.length === 1 ? "member" : "members" }}
        </span>
        <span class="team-stat team-stat--active">
          <strong>{{ activeUsersCount }}</strong> active
        </span>
        <span class="team-stat team-stat--inactive" *ngIf="disabledUsersCount">
          <strong>{{ disabledUsersCount }}</strong> disabled
        </span>
      </div>
    </div>

    <div class="team-panel__tools">
      <div class="team-search" *ngIf="users.length > 1">
        <i class="material-icons team-search__icon">search</i>
        <input
          type="text"
          class="team-search__input"
          placeholder="Search by name, username, email or location"
          aria-label="Search team members"
          [(ngModel)]="searchTerm"
        />
        <button
          type="button"
          class="team-search__clear"
          *ngIf="searchTerm"
          (click)="clearSearch()"
          aria-label="Clear search"
        >
          <i class="material-icons">close</i>
        </button>
      </div>

      <button
        mat-flat-button
        color="primary"
        class="team-panel__add"
        (click)="addUser()"
      >
        <i class="material-icons">person_add</i>
        <span>Add user</span>
      </button>
    </div>
  </header>

  <div class="team-list" *ngIf="!isLoading">
    <article
      class="member-row"
      *ngFor="let currentUser of filteredUsers; trackBy: trackByUserId"
      [class.member-row--inactive]="!currentUser.isActive"
    >
      <div class="member-row__identity">
        <div
          class="member-avatar"
          [ngClass]="'member-avatar--tone-' + avatarTone(currentUser)"
          aria-hidden="true"
        >
          {{ initials(currentUser) }}
        </div>
        <div class="member-identity">
          <p class="member-name">
            {{ currentUser.firstName }} {{ currentUser.lastName }}
            <span class="member-tag" *ngIf="currentUser.isOrganizationAdmin">
              Admin
            </span>
          </p>
          <p class="member-meta">
            <span class="member-username">{{ currentUser.username }}</span>
            <span class="member-meta__sep" *ngIf="currentUser.email">•</span>
            <span class="member-email" *ngIf="currentUser.email">
              {{ currentUser.email }}
            </span>
          </p>
        </div>
      </div>

      <div class="member-row__locations">
        <app-location-badge
          *ngFor="let location of visibleLocations(currentUser)"
          [location]="location"
        ></app-location-badge>

        <button
          type="button"
          class="member-locations__toggle"
          *ngIf="hiddenLocationsCount(currentUser) > 0"
          (click)="toggleLocations(currentUser)"
        >
          +{{ hiddenLocationsCount(currentUser) }} more
        </button>
        <button
          type="button"
          class="member-locations__toggle"
          *ngIf="isLocationsExpanded(currentUser)"
          (click)="toggleLocations(currentUser)"
        >
          Show less
        </button>

        <span class="member-locations__empty" *ngIf="!currentUser.userLocations?.length">
          No locations assigned
        </span>
      </div>

      <div class="member-row__status">
        <span
          class="status-pill"
          [class.status-pill--active]="currentUser.isActive"
        >
          <span class="status-pill__dot"></span>
          {{ currentUser.isActive ? "Active" : "Disabled" }}
        </span>

        <button
          mat-icon-button
          class="member-menu-trigger"
          [matMenuTriggerFor]="menu"
          aria-label="Member actions"
        >
          <i class="material-icons">more_vert</i>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" class="member-menu">
          <button mat-menu-item (click)="editUser(currentUser)">
            <i class="material-icons" matMenuItemIcon>edit</i>
            <span>Edit</span>
          </button>
          <button mat-menu-item (click)="toggleUserStatus(currentUser)">
            <i class="material-icons" matMenuItemIcon>
              {{ currentUser.isActive ? "block" : "check_circle_outline" }}
            </i>
            <span>{{ currentUser.isActive ? "Disable" : "Enable" }}</span>
          </button>
          <button
            mat-menu-item
            class="qb-menu-danger"
            (click)="deleteUser(currentUser)"
          >
            <i class="material-icons" matMenuItemIcon>delete_outline</i>
            <span>Delete</span>
          </button>
        </mat-menu>
      </div>
    </article>

    <div class="team-empty" *ngIf="!users.length">
      <i class="material-icons team-empty__icon">group_add</i>
      <p class="team-empty__title">No team members yet</p>
      <p class="team-empty__text">
        Invite your colleagues so they can access the locations you manage.
      </p>
      <button mat-flat-button color="primary" (click)="addUser()">
        Add your first user
      </button>
    </div>

    <div class="team-empty" *ngIf="users.length && !filteredUsers.length">
      <i class="material-icons team-empty__icon">search_off</i>
      <p class="team-empty__title">No members match “{{ searchTerm }}”</p>
      <p class="team-empty__text">Try a different name, username or location.</p>
      <button type="button" class="team-empty__link" (click)="clearSearch()">
        Clear search
      </button>
    </div>
  </div>

  <div class="team-list team-list--loading" *ngIf="isLoading" aria-busy="true">
    <div class="member-skeleton" *ngFor="let placeholder of skeletonRows">
      <div class="skeleton skeleton--avatar"></div>
      <div class="member-skeleton__lines">
        <div class="skeleton skeleton--line skeleton--line-lg"></div>
        <div class="skeleton skeleton--line skeleton--line-sm"></div>
      </div>
      <div class="skeleton skeleton--chip"></div>
      <div class="skeleton skeleton--pill"></div>
    </div>
  </div>
</section>
